import { format } from 'date-fns';

import type { DocumentType } from '@/gql';

import type { CSV_CONVERSATION_ITEM_FRAGMENT } from './BulkDownloadDialog';

export const convertDataToCsv = (
  data: Array<
    DocumentType<typeof CSV_CONVERSATION_ITEM_FRAGMENT> | null | undefined
  >,
) => {
  const escapeCsvField = (field: string | undefined | null) => {
    if (field == null) return '';
    return '"' + String(field).replace(/"/g, '""') + '"';
  };
  const header = 'Prompt,Response,Knowledge Sources,Intercom Sources';
  const csv = data
    .map((item) => {
      return [
        escapeCsvField(item?.prompt?.text),
        escapeCsvField(item?.response?.responseText),
        escapeCsvField(
          item?.response?.knowledgeSourcesConnection?.edges
            ?.map((edge) => `${edge?.node?.title} (${edge?.node?.url})`)
            ?.join('\n') ?? '',
        ),
        escapeCsvField(
          item?.response?.intercomSourcesConnection?.edges
            ?.map((edge) => `${edge?.node?.title} (${edge?.node?.url})`)
            ?.join('\n') ?? '',
        ),
      ].join(',');
    })
    .join('\n');
  return `${header}\n${csv}`;
};

export const downloadCsv = (csv: string, timestamp: Date) => {
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const dateString = format(timestamp, 'd-M-y HH_mm');
  a.download = `conversations-${dateString}.csv`;
  a.click();
};
